/* tslint:disable */

/**
 */
export class ViewDwellingTimes {
    name?: number;
    value?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-dwelling-times.ts